import DatabaseAttendClientRepository from "@domain/repositories/DatabaseAttendClientRepository";
import { UserStore } from "@domain/stores/UserStore";
import UseCase from "@domain/UseCase";
import { Paging } from "@domain/models/Paging";
import { userRoles } from "@domain/models/User";

type Input = {
  paging: Paging;
};

type Output = void;

export class WatchTableAttendClientsUseCase implements UseCase<Input, Output> {
  constructor(
    private readonly userStore: UserStore,
    private readonly databaseAttendClientRepository: DatabaseAttendClientRepository
  ) {}
  execute({ paging }: Input) {
    const user = this.userStore.user;

    if (user.role === userRoles.root || user.role === userRoles.admin) {
      return this.databaseAttendClientRepository.watchAttendClientsAdmin(paging);
    }

    if (user.role === userRoles.manager) {
      return this.databaseAttendClientRepository.watchAttendClientsManager(
        paging,
        user.operatorsIds
      );
    }

    return;
  }
}
